import 'focus-visible';
import { createGlobalStyle } from 'styled-components';
import { FONT_SIZE_BASE } from '../theme/constants';
export const GlobalStyle = createGlobalStyle `
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body {
    font-family: Helvetica, Arial, sans-serif;
    font-size: ${FONT_SIZE_BASE}px;
  }

  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
  }
`;
//# sourceMappingURL=GlobalStyle.js.map